import React, {useEffect, useState} from 'react';

import CanvasJSChart from "./CanvasJSChart";
import SpinnerDiv from "root/Components/SpinnerDiv";

import { getPanelHeader } from "./DashboardPanelFunctions";
import {getDataFromResponse, getNumRowsFromResponse} from "root/DataFunctions/BaseDataFns";
import {getLoginsForOrg} from "root/DataFunctions/DashboardDataFns";
import {useGlobalContext} from "root/contexts/GlobalContext";

const DashboardPanelOrgLogins = (props) =>
{
	const [ data, setData ] = useState ({ loading: true, data: []}) ;

	const { user_org } = useGlobalContext() ;

	useEffect(() =>
	{
		getServerData() ;
	}, [props.user_type, props.month]);

    const generateDataPoints = ( items ) =>
	{
		return items.map ((item) =>
			{
				return ({
					y: Number(item.count),
					label: item.fullName,
					tool: item.count
				})
			}
		)
	}

	const getServerData = () => {

		getLoginsForOrg( props.user_type, props.month, props.year, user_org,(response) =>
		{
			const recs = getDataFromResponse(response);

			setData ( { loading: false, data : recs}) ;
		});
	};

	const formPanelHorizontal = () =>
	{
		const options = {
			maintainAspectRatio: false,
			responsive: true,
			animationEnabled: true,
			height: props.height,
			title: {
				text: props.title
			},
			axisX: {
				interval: 1,
				labelFontSize: 14
			},
			axisY2: {
				gridColor: "rgba(1,77,101,.1)",
				title: props.title,
				chartlabelFontSize: 14
			},
			data: [
				{
					type: 'column',
					axisYType: "primary",
					lineColor: 'red',
					indexLabelPlacement: 'inside',    //Try Changing to outside
					showInLegend: true,
					legendMarkerColor: 'grey',
					legendText: 'Number of Logins',
					toolTipContent: '{tool}',
					dataPoints: generateDataPoints(data.data)
				}
			] } ;

		return (
			<div className={'panel ' + props.panelStyle}>
				{ getPanelHeader({ title: props.title })}
				<div className='panel-body'>
					<CanvasJSChart id='chartChildAge' options={options} uniqueId='chartChildAge' />
				</div>
			</div>
		)
	}

	const formPanelVertical = () =>
	{
		const options = {
			maintainAspectRatio: false,
			responsive: true,
			animationEnabled: true,
			height: props.height,
			title: {
				text: props.title
			},
			data: [
				{
					type: 'column',
					lineColor: 'red',
					indexLabelPlacement: 'inside',    //Try Changing to outside
					showInLegend: true,
					legendMarkerColor: 'grey',
					legendText: 'Number of Logins',
					toolTipContent: '{tool}',
					dataPoints: generateDataPoints(data.data)
				}
			] } ;

		return (
			<div className={'panel ' + props.panelStyle}>
				{ getPanelHeader({ title: '' })}
				<div className='panel-body'>
					<CanvasJSChart id='chartChildAge' options={options} uniqueId='chartChildAge' />
				</div>
			</div>
		)
	}

	return data.loading === true ? <SpinnerDiv/> : formPanelHorizontal() ;
}

export default DashboardPanelOrgLogins;

DashboardPanelOrgLogins.defaultProps =
{
	title: 'title',
	height: 500,
	panelStyle: 'panel-default',
}